const LS_PARTNER_REFERRAL = 'accestra_partner_referral';
const MAX_REFERRAL_AGE_MS = 1000 * 60 * 60 * 24 * 45;

interface StoredPartnerReferral {
  code: string;
  capturedAt: string;
}

function normalizePartnerReferralCode(value: string | null | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim().toUpperCase();
  if (!trimmed) {
    return null;
  }

  return /^[A-Z0-9-]{2,80}$/.test(trimmed) ? trimmed : null;
}

export function capturePartnerReferralCodeFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  const nextCode = normalizePartnerReferralCode(params.get('ref'));
  if (!nextCode) {
    return null;
  }

  try {
    const payload: StoredPartnerReferral = {
      code: nextCode,
      capturedAt: new Date().toISOString(),
    };
    localStorage.setItem(LS_PARTNER_REFERRAL, JSON.stringify(payload));
  } catch {
    // Ignore storage failures.
  }

  return nextCode;
}

export function getStoredPartnerReferralCode(): string | null {
  try {
    const raw = localStorage.getItem(LS_PARTNER_REFERRAL);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as Partial<StoredPartnerReferral>;
    const code = normalizePartnerReferralCode(parsed.code);
    const capturedAt = typeof parsed.capturedAt === 'string' ? new Date(parsed.capturedAt) : null;

    if (!code || !capturedAt || Number.isNaN(capturedAt.getTime())) {
      localStorage.removeItem(LS_PARTNER_REFERRAL);
      return null;
    }

    if (Date.now() - capturedAt.getTime() > MAX_REFERRAL_AGE_MS) {
      localStorage.removeItem(LS_PARTNER_REFERRAL);
      return null;
    }

    return code;
  } catch {
    return null;
  }
}

export function clearStoredPartnerReferralCode(): void {
  try {
    localStorage.removeItem(LS_PARTNER_REFERRAL);
  } catch {
    // Ignore storage failures.
  }
}
